export function createCustomer (data) {
  return {
    ...data,
    name: `${data.first_name} ${data.last_name}`,
  };
}
